import styled from 'styled-components'
import { em } from 'polished'

import { BoxBase } from 'styles/components/layout'
import { Text } from 'shared/Typography'

export const PersonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${p => p.theme.mq.downMd} {
  }
`

export const PersonImage = styled.img`
  display: block;
  max-width: ${em(60)};
  margin-bottom: ${em(8)};

  ${p => p.theme.mq.upLg} {
    max-width: ${em(100)};
  }
`

export const PersonTitle = styled(Text)`
  ${({ theme }) => theme.mq.downMd} {
    font-size: 10px;
  }
`
export const PersonText = styled(Text)`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${p => p.color};

  ${({ theme }) => theme.mq.downMd} {
    font-size: 10px;
  }

  &:after {
    content: '';
    display: block;
    width: ${em(1)};
    height: ${em(45)};
    margin-top: ${em(10)};
    background-color: ${p => p.color};

    ${p => p.theme.mq.upLg} {
      height: ${em(80)};
    }
  }
`
